// @mui
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Grid,
  Card,
  Divider,
  Table,
  TableBody,
  TableContainer,
  Typography,
  Box,
  TableHead,
  TableRow,
  TableCell,
  Tab,
  AccordionDetails,
  Accordion,
  AccordionSummary,
  Paper,
  Tooltip,
  IconButton,
} from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import DownloadIcon from '@mui/icons-material/Download';
// @types

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
//Localization
import useLocales from 'src/hooks/useLocales';

import { IContractInfo } from 'src/@types/Choqorak/MainTables/Contract/ContractInfo';
import { IRentPayment } from 'src/@types/Choqorak/MainTables/RentPayment.ts/RentPayment';
import { IElectricityPayment } from 'src/@types/Choqorak/MainTables/ElectricityPayment/ElectricityPayment';
import { DateConverter } from 'src/sections/common/DateConverter';
import { GetMonthName } from 'src/sections/common/GetMonthName';
import Label from 'src/components/Label';
import CalculateDuration from 'src/sections/common/CalculateDuration';
import { observer } from 'mobx-react-lite';
import { baseUrl } from 'src/api/baseUrl';
import Iconify from 'src/components/Iconify';
import { useStore } from 'src/stores/store';
import MyDialog from 'src/components/MyDialog';
import RentPaymentDetailTable from '../RentPayment/RentPaymentDetails/RentPaymentDetailTable';
import ElectricityPaymentDetailTable from '../ElectricityPayment/ElectricityPaymentDetails/ElectricityPaymentDetailTable';

type Props = {
  electricityRow?: IElectricityPayment[];
  rentRow?: IRentPayment[];
  contractRow?: IContractInfo[];
  historyTitle?: string;
};

export default observer(function HistoryComponent({
  historyTitle,
  electricityRow,
  rentRow,
  contractRow,
}: Props) {

  const { RentPaymentStore, ElectricityPaymentStore } = useStore();

  const {
    loadRentPaymentDetail,
    setOpenCloseDetailsDialog,
    openDetailsDialog,
  } = RentPaymentStore;

  const {

    loadElectricityPaymentDetail,

    setOpenCloseEletricDetailsDialog,

    openEletricDetailsDialog
  } = ElectricityPaymentStore;
  const { translate } = useLocales(); //Localization
  const [value, setValue] = useState('1');
  const [expanded, setExpanded] = useState<string | false>(false);
  const [expandedRent, setExpandedRent] = useState<string | false>(false);
  const [expandedElectric, setExpandedElectric] = useState<string | false>(false);
  const handleChange = (event: SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };
  const handleChangeAcc = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleChangeRentAcc =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedRent(isExpanded ? panel : false);
    };
  const handleChangeElectricAcc =
    (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedElectric(isExpanded ? panel : false);
    };

  const groupedRentByContract = (rentRow ?? []).reduce((acc, item) => {
    const contractName = item.contractNumber || 'unknown'; // Use "unknown" as a fallback if contractNumber is undefined

    if (!acc[contractName]) {
      acc[contractName] = [];
    }

    acc[contractName].push(item);

    return acc;
  }, {} as Record<string, IRentPayment[]>);

  const groupedElectricityByContract = (electricityRow ?? []).reduce((acc, item) => {
    const year = item.year || 'unknown'; // Use "unknown" as a fallback if contractNumber is undefined

    if (!acc[year]) {
      acc[year] = [];
    }

    acc[year].push(item);

    return acc;
  }, {} as Record<string, IElectricityPayment[]>);

  const handleOpenDetailsModal = async (id: number) => {
    await loadRentPaymentDetail({ rentPaymentId: id }).then(() => {
      setOpenCloseDetailsDialog();

    });
  };

  const handleCloseDetailsModal = () => {
    setOpenCloseDetailsDialog();
  };

  const handleOpenEletricDetailsModal = async (id: number) => {
    await loadElectricityPaymentDetail({ electricityPaymentId: id }).then(() => {
      setOpenCloseEletricDetailsDialog();

    });
  };

  const handleCloseEletricDetailsModal = () => {
    setOpenCloseEletricDetailsDialog();
  };

  let Url = baseUrl;
  return (
    <>
      <Grid item xs={12} style={{ marginTop: 30 }}>
        <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Typography variant="h6" sx={{ p: 2, fontWeight: 'bold' }}>
            {historyTitle} {translate('Shop.History')}
          </Typography>
          <Box sx={{ width: '100%', typography: 'body1', p: 3 }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="lab API tabs example">
                  {contractRow ? <Tab label={translate('Shop.ContractHistory')} value="1" /> : ''}
                  {rentRow ? <Tab label={translate('Shop.RentPyamentHistory')} value="2" /> : ''}
                  {electricityRow ? (
                    <Tab label={translate('Shop.ElectricityPaymenyHistory')} value="3" />
                  ) : (
                    ''
                  )}
                </TabList>
              </Box>
              <TabPanel value="1">
                {contractRow?.map((data, index) => (
                  <div key={index}>
                    <Accordion
                      expanded={expanded === index.toString()}
                      onChange={handleChangeAcc(index.toString())}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1bh-content"
                        id="panel1bh-header"
                      >
                        <Typography component="span" sx={{ width: '20%', flexShrink: 0 }}>
                          {translate('contractsInfo.ContractNumber')} :{' '}
                          <Label color="success">{data.contractNumber}</Label>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{ color: 'text.secondary', width: '30%', flexShrink: 0 }}
                        >
                          {translate('Customer.Customer')}: {data.customerName}
                        </Typography>
                        <Typography
                          component="span"
                          sx={{ color: 'text.secondary', width: '20%', flexShrink: 0 }}
                        >
                          {translate('contractsInfo.StartDate')} :{' '}
                          {<DateConverter date={data.contractStartDate} />}
                        </Typography>
                        <Typography
                          component="span"
                          sx={{ color: 'text.secondary', width: '20%', flexShrink: 0 }}
                        >
                          {translate('contractsInfo.EndDate')} :{' '}
                          {<DateConverter date={data.contractEndDate} />}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} md={12}>
                          <Card sx={{ p: 2 }}>
                            <TableContainer component={Paper}>
                              <Table
                                sx={{ minWidth: '100%' }}
                                size="small"
                                aria-label="a dense table"
                              >
                                {/* <caption>A basic table example with a caption</caption> */}
                                <TableBody>
                                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('RentPaymentPrint.CustomerPhone')}
                                    </TableCell>
                                    <TableCell align="left">{data.customerPhone}</TableCell>

                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('Shop.ShopCode')}
                                    </TableCell>
                                    <TableCell align="left">{data.shopCode}</TableCell>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('ContractType.ContractType')}
                                    </TableCell>
                                    <TableCell align="left">{data.contractType}</TableCell>
                                  </TableRow>
                                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('Shop.RentPerMonth')}
                                    </TableCell>
                                    <TableCell align="left">{data.finalRentPerMonth}</TableCell>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('contractsInfo.TotalContractDurationRent')}
                                    </TableCell>
                                    <TableCell align="left">
                                      {Math.floor(data.totalContractDurationRent!)}
                                    </TableCell>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('contractsInfo.TotalContractDurationPaidRent')}
                                    </TableCell>
                                    <TableCell align="left">
                                      {data.totalContractDurationPaidRent}
                                    </TableCell>
                                  </TableRow>
                                  {data.discountStartDate && data.discountEndDate ? (
                                    <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontWeight: 'bold',
                                          color: 'info.main',
                                          fontSize: '16px',
                                        }}
                                      >
                                        {translate('contractsInfo.DiscountStartDate')}
                                      </TableCell>
                                      <TableCell align="left">
                                        {<DateConverter date={data.discountStartDate} />}
                                      </TableCell>

                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontWeight: 'bold',
                                          color: 'info.main',
                                          fontSize: '16px',
                                        }}
                                      >
                                        {translate('contractsInfo.DiscountEndDate')}
                                      </TableCell>
                                      <TableCell align="left">
                                        {<DateConverter date={data.discountEndDate} />}
                                      </TableCell>

                                      <TableCell
                                        align="left"
                                        sx={{
                                          fontWeight: 'bold',
                                          color: 'info.main',
                                          fontSize: '16px',
                                        }}
                                      >
                                        {translate('contractsInfo.DurationOfDiscount')}
                                      </TableCell>
                                      <TableCell align="left">
                                        {CalculateDuration(
                                          translate,
                                          data.discountStartDate,
                                          data.discountEndDate
                                        )}
                                      </TableCell>
                                    </TableRow>
                                  ) : (
                                    ''
                                  )}
                                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('contractsInfo.AdvancePayment')}
                                    </TableCell>
                                    <TableCell align="left">{data.advancePayment}</TableCell>

                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('contractsInfo.AdvanceRecievedByUserName')}
                                    </TableCell>
                                    <TableCell align="left">
                                      {data.advanceRecievedByUserName}
                                    </TableCell>

                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('contractsInfo.Status')}
                                    </TableCell>
                                    <TableCell align="left">{data.contractStatus}</TableCell>
                                  </TableRow>

                                  <TableRow sx={{ borderBottom: '1px solid rgba(60,60,60,.9)' }}>
                                    <TableCell
                                      align="left"
                                      sx={{
                                        fontWeight: 'bold',
                                        color: 'info.main',
                                        fontSize: '16px',
                                      }}
                                    >
                                      {translate('contractsInfo.Terminated')}
                                    </TableCell>
                                    <TableCell align="left">
                                      {data.isTerminated === true
                                        ? `${translate('contractsInfo.Terminated')}`
                                        : `${translate('contractsInfo.NotTerminated')}`}
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Card>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))}
              </TabPanel>
              <TabPanel value="2">
                {' '}
                {Object.entries(groupedRentByContract).map(([contractNumber, group], index) => (
                  <div key={index}>
                    <Accordion
                      expanded={expandedRent === index.toString()}
                      onChange={handleChangeRentAcc(index.toString())}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                      >
                        <Typography component="span" sx={{ width: '20%', flexShrink: 0 }}>
                          {translate('contractsInfo.ContractNumber')} :{' '}
                          <Label color="success">{contractNumber}</Label>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{ color: 'text.secondary', width: '30%', flexShrink: 0 }}
                        >
                          {translate('Customer.Customer')}: {group[0]?.customerName ?? 'N/A'}
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} md={12}>
                          <Card sx={{ p: 2 }}>
                            <TableContainer sx={{ minWidth: 720 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>{translate('RentPayment.Year')}</TableCell>
                                    <TableCell>{translate('RentPayment.Month')}</TableCell>
                                    <TableCell>{translate('Customer.CustomerName')}</TableCell>
                                    <TableCell>{translate('Shop.ShopCode')}</TableCell>
                                    <TableCell>{translate('RentPayment.RecievedByUserName')}</TableCell>
                                    <TableCell>{translate('RentPayment.PaymentAmount')}</TableCell>
                                    <TableCell>{translate('RentPayment.PaidAmount')}</TableCell>
                                    <TableCell>{translate('RentPayment.RemainAmount')}</TableCell>
                                    <TableCell>{translate('RentPayment.PaymentDate')}</TableCell>
                                    <TableCell>{translate('GeneralFields.Action')}</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {group.map((data, rowIndex) => (
                                    <TableRow key={rowIndex}>
                                      <TableCell align="left">{data.year ?? 'N/A'}</TableCell>
                                      <TableCell align="left"><Label color="info">{GetMonthName(data.month)}</Label></TableCell>
                                      <TableCell align="left">{data.customerName ?? 'N/A'}</TableCell>
                                      <TableCell align="left">{data.shopCode ?? 'N/A'}</TableCell>
                                      <TableCell align="left">{data.recievedByUserName ?? 'N/A'}</TableCell>
                                      <TableCell align="left">{data.paymentAmount ?? 'N/A'}</TableCell>
                                      <TableCell align="left">{data.paidAmount ?? 'N/A'}</TableCell>
                                      <TableCell align="left">
                                        {data.remainAmount === 0 ? (
                                          <Label color="success">{translate('RentPayment.Paid')}</Label>
                                        ) : (
                                          data.remainAmount
                                        )}
                                      </TableCell>
                                      <TableCell align="left">{<DateConverter date={data.paymentDate} />}</TableCell>
                                      <TableCell>
                                        <Tooltip title={translate('View Details')}>
                                          <IconButton
                                            color="primary"
                                            size="small"
                                            onClick={() => {
                                              if (data.rentPaymentId) {
                                                handleOpenDetailsModal(data.rentPaymentId);
                                              }
                                            }}
                                          >
                                            <Iconify icon="eva:eye-outline" width={20} height={20} />
                                          </IconButton>
                                        </Tooltip>
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>

                              </Table>
                            </TableContainer>
                          </Card>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))}
              </TabPanel>
              <TabPanel value="3">
                {Object.entries(groupedElectricityByContract).map(([year, group], index) => (
                  <div key={index}>
                    <Accordion
                      expanded={expandedElectric === index.toString()}
                      onChange={handleChangeElectricAcc(index.toString())}
                    >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls={`panel${index}-content`}
                        id={`panel${index}-header`}
                      >
                        <Typography component="span" sx={{ width: '20%', flexShrink: 0 }}>
                          {translate('ElectricityPayment.Year')} :{' '}
                          <Label color="success">{year}</Label>
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} md={12}>
                          <Card sx={{ p: 2 }}>
                            <TableContainer sx={{ minWidth: 720 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    <TableCell>{translate('RentPayment.Year')}</TableCell>
                                    <TableCell>{translate('RentPayment.Month')}</TableCell>
                                    <TableCell>{translate('Customer.CustomerName')}</TableCell>
                                    <TableCell>{translate('Shop.ShopCode')}</TableCell>
                                    <TableCell>
                                      {translate('RentPayment.RecievedByUserName')}
                                    </TableCell>
                                    <TableCell>{translate('RentPayment.PaymentAmount')}</TableCell>
                                    <TableCell>{translate('RentPayment.PaidAmount')}</TableCell>
                                    <TableCell>{translate('RentPayment.RemainAmount')}</TableCell>
                                    <TableCell>{translate('RentPayment.PaymentDate')}</TableCell>
                                    <TableCell>{translate('GeneralFields.Action')}</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>                                  {group.map((data, rowIndex) => (

                                  <TableRow key={rowIndex}>
                                    <TableCell align="left">{data.year ?? 'N/A'}</TableCell>
                                    <TableCell align="left">
                                      <Label color="info">{GetMonthName(data.month)}</Label>
                                    </TableCell>
                                    <TableCell align="left">
                                      {data.customerName ?? 'N/A'}
                                    </TableCell>
                                    <TableCell align="left">{data.shopCode ?? 'N/A'}</TableCell>
                                    <TableCell align="left">
                                      {data.recievedByUserName ?? 'N/A'}
                                    </TableCell>
                                    <TableCell align="left">
                                      {data.paymentAmount ?? 'N/A'}
                                    </TableCell>
                                    <TableCell align="left">{data.paidAmount ?? 'N/A'}</TableCell>
                                    <TableCell align="left">
                                      {data.remainAmount === 0 ? (
                                        <Label color="success">
                                          {' '}
                                          {translate('RentPayment.Paid')}
                                        </Label>
                                      ) : (
                                        data.remainAmount
                                      )}
                                    </TableCell>
                                    <TableCell align="left">
                                      {<DateConverter date={data.paymentDate} />}
                                    </TableCell>
                                    <TableCell>
                                      <Tooltip title={translate('CRUD.Detail')}>
                                        <IconButton
                                          color="primary"
                                          size="small"
                                          onClick={() => {
                                            if (data.electricityPaymentId) {
                                              handleOpenEletricDetailsModal(data.electricityPaymentId); // You should define this function
                                            }
                                          }}
                                        >
                                          <Iconify icon="eva:eye-outline" width={20} height={20} />
                                        </IconButton>
                                      </Tooltip>
                                    </TableCell>
                                  </TableRow>
                                ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Card>
                        </Grid>
                      </AccordionDetails>
                    </Accordion>
                  </div>
                ))}
              </TabPanel>
            </TabContext>
          </Box>
          <Divider sx={{ borderColor: 'grey.700' }} />
        </Card>
        <MyDialog
          open={openDetailsDialog}
          onClose={handleCloseDetailsModal}
          title=""
          size="xl"
        >
          <RentPaymentDetailTable

          />
        </MyDialog>

        <MyDialog
          open={openEletricDetailsDialog}
          onClose={handleCloseEletricDetailsModal}
          title=""
          size="xl"
        >
          <ElectricityPaymentDetailTable

          />
        </MyDialog>
      </Grid >
    </>
  );
});

//---------------------------------------------
